<template>
  <button type="button" class="unstyled-button" :title="title" :disabled="disabled" @click="onClick">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },

  emits: ['click'],

  methods: {
    onClick: function() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
  .unstyled-button {
    padding: 0;
    border: none;
    font: inherit;
    color: inherit;
    background-color: transparent;
    cursor: pointer;
  }
</style>
